export default function Community() {
    const features = [
        {
            title: "Network with Curious Minds",
            description:
                "Engage in thought-provoking conversations with students, professionals, and enthusiasts from around the world.",
        },
        {
            title: "Ready to Explore?",
            description:
                "Start your journey with fellow GEO enthusiasts and stay informed about what shapes our world.",
            cta: {
                label: "Join the WhatsApp Group",
                href: "https://wa.me/your-group-link",
            },
        },
        {
            title: "Free Resources",
            description:
                "Access curated articles, maps, and exclusive learning materials to deepen your understanding of the world.",
        },
    ];

    return (
        <section className="bg-canvas font-sans py-5">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <h2 className="text-center font-sans text-xs font-semibold uppercase tracking-wide text-accent">
                    Join the GEO Community
                </h2>
                <p className="mt-4 text-center font-display text-4xl sm:text-5xl font-normal tracking-tight leading-tight text-ink max-w-3xl mx-auto">
                    Connect, Learn, and Explore the World Together
                </p>

                <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                    {features.map(({ title, description, cta }, idx) => (
                        <div
                            key={idx}
                            className="relative rounded-2xl border border-border bg-surface p-6 flex flex-col justify-between"
                        >
                            <div>
                                <h3 className="font-display text-xl font-normal text-ink mb-2">
                                    {title}
                                </h3>
                                <p className="text-sm text-ink-muted">
                                    {description}
                                </p>
                            </div>
                            {cta && (
                                <a
                                    href={cta.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="mt-6 inline-flex items-center justify-center rounded-lg bg-accent px-5 py-2.5 text-white text-sm font-medium text-center hover:bg-accent-hover transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2"
                                >
                                    {cta.label}
                                </a>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
